import { render } from "./Risk_Detail.vue?vue&type=template&id=0195ae58&scoped=true"
import script from "./Risk_Detail.vue?vue&type=script&lang=js"
export * from "./Risk_Detail.vue?vue&type=script&lang=js"

import "./Risk_Detail.vue?vue&type=style&index=0&id=0195ae58&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0195ae58"

export default script